// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"76":"common","96":"vendors","472":"chunk-editor","679":"slides-go-banner"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};